import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import 'roboto-fontface/css/roboto/roboto-fontface.css';
import '@mdi/font/css/materialdesignicons.css';
import Axios from 'axios';
Vue.config.productionTip = false;
Axios.defaults.baseURL = process.env.VUE_APP_API_URL;
if (process.env.VUE_APP_API_PASSWORD && process.env.VUE_APP_API_LOGIN) {
    Axios.defaults.auth = {
        username: process.env.VUE_APP_API_LOGIN,
        password: process.env.VUE_APP_API_PASSWORD
    };
    Axios.defaults.withCredentials = true;
}
new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
}).$mount('#app');
